import { lazy } from 'react'
import { type RouteObject } from 'react-router-dom'

const MasterDataHubPage = lazy(() => import('./pages/master-data-hub'))
const RawMaterialPage = lazy(() => import('./pages/raw-material'))
const SpecDetailDrawerPage = lazy(() => import('./pages/raw-material/features/spec-detail-drawer'))
const SupplierPage = lazy(() => import('./pages/supplier'))
const CustomerListPage = lazy(() => import('./pages/customer/features/customer-list'))
const CreateCustomerPage = lazy(() => import('./pages/customer/features/create-customer'))
const DetailCustomerPage = lazy(() => import('./pages/customer/features/detail-customer'))
const EditCustomerPage = lazy(() => import('./pages/customer/features/edit-customer'))
const MesinProduksiPage = lazy(() => import('./pages/mesin-produksi'))
const SkuFgPage = lazy(() => import('./pages/sku-fg'))
const BomPerSkuPage = lazy(() => import('./pages/bom-per-sku'))
const PalletRmPage = lazy(() => import('./pages/pallet-rm'))
const AlasanNgPage = lazy(() => import('./pages/alasan-ng'))
const LocationWharehousePage = lazy(() => import('./pages/lokasi-gudang'))
const MasterUnitPage = lazy(() => import('./pages/master-unit'))

const masterDataRoutes: RouteObject[] = [
  {
    path: 'master-data',
    children: [
      {
        index: true,
        element: <MasterDataHubPage />
      },
      {
        path: 'hub',
        element: <MasterDataHubPage />
      },
      {
        path: 'master-sku-fg',
        children: [
          {
            index: true,
            element: <SkuFgPage />
          },
          {
            path: 'add',
            element: <SkuFgPage />
          },
          {
            path: ':id',
            element: <SkuFgPage />
          },
          {
            path: ':id/edit',
            element: <SkuFgPage />
          }
        ]
      },
      {
        path: 'master-raw-material',
        children: [
          {
            index: true,
            element: <RawMaterialPage />
          },
          {
            path: 'spec-detail',
            element: <SpecDetailDrawerPage />
          }
        ]
      },
      {
        path: 'mst-03a',
        element: <SpecDetailDrawerPage />
      },
      {
        path: 'master-bom',
        element: <BomPerSkuPage />
      },
      {
        path: 'master-supplier',
        element: <SupplierPage />
      },
      {
        path: 'master-customer',
        children: [
          {
            index: true,
            element: <CustomerListPage />
          },
          {
            path: 'add',
            element: <CreateCustomerPage />
          },
          {
            path: ':id',
            element: <DetailCustomerPage />
          },
          {
            path: ':id/edit',
            element: <EditCustomerPage />
          }
        ]
      },
      {
        path: 'master-lokasi',
        element: <LocationWharehousePage />
      },
      {
        path: 'master-mesin',
        element: <MesinProduksiPage />
      },
      {
        path: 'master-sla',
        element: <></>
      },
      {
        path: 'master-alasan-ng',
        element: <AlasanNgPage />
      },
      {
        path: 'master-pallet',
        element: <PalletRmPage />
      },
      {
        path: 'mst-10',
        element: <AlasanNgPage />
      },
      {
        path: 'master-unit',
        element: <MasterUnitPage />
      }
    ]
  },
  {
    path: 'mst-03a',
    element: <SpecDetailDrawerPage />
  },
  {
    path: 'mst-10',
    element: <PalletRmPage />
  }
]

export default masterDataRoutes
